import { IconButton, MimaText, PageLoader, MimaButton } from '../../components';
import { amountFormatter, capitalizeFirstLetter } from '../../utils/utils';
import styles from '../../assets/styles/Subwallet/Subwallet.module.scss';
import { walletStore } from '../../stores';
import React, { useState } from 'react';

const SubBalanceCard = ({ wallet, loading, showViewMore, transfer }) => {
	const [hide, setHide] = useState(true);

	let eye;
	!hide ? (eye = 'eyeOpen') : (eye = 'eyeClose');

	const balanceToggle = () => {
		setHide(!hide);
	};
	return (
		<div className={styles.balance}>
			<MimaText mt={3} mb={3} variant="subtitle" align="center">
				{wallet.name}
			</MimaText>

			<div className={styles.balance__amount}>
				<div>
					<MimaText>Balance</MimaText>
					{loading ? (
						<PageLoader title="Refreshing record..." loading={loading} />
					) : (
						<>
							<MimaText variant="h3">
								{!hide ? amountFormatter().format(wallet.balance) : '*******'}
							</MimaText>

							<MimaText color="var(--color-error)">
								{!hide
									? `Limit: ${amountFormatter().format(wallet.limit)}`
									: '*******'}
							</MimaText>
							<MimaText variant="smallBold">{`Period: ${capitalizeFirstLetter(
								wallet.limitPeriod
							)}`}</MimaText>
						</>
					)}
				</div>

				<IconButton onClick={() => balanceToggle()} variant={eye} />
			</div>

			<div className={styles.balance__btns}>
				<MimaButton
					title="Make Payment"
					variant="filter"
					onClick={() => {
						walletStore.setSelectedSubWallet(wallet);
						transfer();
					}}
					buttonColor="var(--color-primary)"
					width={16}
				/>
				<MimaButton
					title="More Details"
					variant="filter"
					onClick={() => {
						walletStore.setSelectedSubWallet(wallet);
						showViewMore();
					}}
					width={16}
				/>
			</div>
		</div>
	);
};

export default SubBalanceCard;
